import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { PublishInfo, JoiEvent } from '../../store/events.era';
import { PublicEventData } from 'globals/store/public.model';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { ConfirmProgramPublishActionDialogComponent, ConfirmPublishActionDialogData } from './program.dialog.confirmPublishAction.component';
import { environment } from 'src/environments/environment';
import { publicEventDataReselector, PublishReselectorData } from 'src/app/store/reselectors/events.reselector';
import { TableLightColors, tableLightColors } from 'src/app/helpers/table-helpers';
import { NestedChecksDialogComponent, NestedChecksDialogData, NestedChecksReturnData } from './../../components/wizards/nested-checks.dialog.component';
import { FilterDialogComponentParams } from 'src/app/components/filters/filters-ui.models';
import { filterPageTypes } from 'src/app/store/filters.era';
import { FiltersDialogComponent } from 'src/app/components/filters/filters-dialog.component';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { getDefaultProgramTabNames, PublishStatus, ShareableItemTypes, shareUrlsByType } from 'globals/store/share.data';
import { VenueSelection } from 'globals/store/programs.data';
import { generateEmailLink, listsMatch, removeFromListByIndex, sleepForMS } from '../../helpers/helpers';
import { venueSelectionsReselector } from 'src/app/store/reselectors/programs.reselector';
import { Venue } from 'globals/store/events.data';
import { programPublishDisplayOptionsNestedFieldCheckGroups } from './program.publish.view.display-options';
import { Wrapper } from 'src/app/components/wrapper.component';
import { BrandOption, BrandingData, SliderImage } from 'globals/store/publish.data';
import publicHelpers from '../../helpers/public-helpers';
import { Dictionary } from '@ngrx/entity';
import { Performer } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { TagType } from 'globals/store/tags.data';
import { EntitySelectorData, EntitySelectorDialogComponent } from '../../components/entities/entity-selector.dialog.component';
import { EntityName } from 'globals/store/entity.data';
import { ManageBrandingComponent, ManageBrandingData } from '../../components/branding/manage-branding.component';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { JoiAccount } from 'globals/store/accounts.data';
import { SliderImageDialogComponent, SliderImageDialogData } from '../../components/branding/slider-image-dialog.component';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { compactDate, jsonCopyObject, str2Date } from 'globals/helpers/helpers';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { TrafficLightComponent } from 'src/app/components/misc/traffic-light.component';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { PublishTimelineComponent } from 'src/app/components/publish-timeline/publish-timeline';
import { BrandingTextComponent } from 'src/app/components/branding/branding-text.component';
import { BrandingTextBlockComponent } from 'src/app/components/branding/branding-text-block.component';
import { BrandingBlockWrapperComponent } from 'src/app/components/branding/branding-block.component';
import { CallsToActionComponent } from 'src/app/components/branding/branding-ctas.component';
import { PerformerGalleryComponent } from '../performers/performer-gallery.component';
import { SponsorGalleryCardComponent } from 'src/app/components/cards/sponsor-gallery-card.component';
import { SliderImageComponent } from 'src/app/components/branding/slider-image.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { ShareCodeComponent } from '../share/share-code.component';
import { ScrollableWrapper } from 'src/app/components/wrappers/scrollable-wrapper.component';
import { PublishBuilderComponent } from 'src/app/components/branding/publish-builder.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { MatButtonModule } from '@angular/material/button';

export const publishStatusToColor: { [key in PublishStatus]: keyof TableLightColors } = { 'published': tableLightColors.green, 'never published': tableLightColors.gray, 'unpublished': tableLightColors.red }
export const publishStatusToText: { [key in PublishStatus]: string } = { 'published': 'Published', 'never published': 'Never published', 'unpublished': 'Unpublished' }
type PublishSubpage = 'DESIGN' | 'CONFIGURE' | 'PREVIEW' | 'PUBLISHED'

@Component({
    selector: 'program-publish-view',
    templateUrl: './program.publish.view.html',
    styleUrls: [`./program.publish.view.scss`],
    standalone: true,
    imports: [JoiNavWrapper, MatButtonModule, TrafficLightComponent, IconTextComponent, PublishTimelineComponent, BrandingTextComponent, BrandingBlockWrapperComponent, CallsToActionComponent, PerformerGalleryComponent, SponsorGalleryCardComponent, SliderImageComponent, IconComponent, CommonModule, LoaderComponent, ShareCodeComponent, ScrollableWrapper, PublishBuilderComponent, IdsToItemsPipe],
})
export class ProgramPublishViewComponent extends Wrapper<ProgramPublishViewComponent> implements OnInit, OnDestroy {

    readonly _file:string = "program.publish.view.ts";
    readonly share_base_url = environment.joi.shareBase;
    page_name = PAGE_NAME.publish;
    @Input() event: JoiEvent
    @Input() publishInfo: PublishInfo
    @Input() editPublishView: Function
    @Input() editCTALinks: Function
    @Input() brandingData: BrandingData
    @Input() startMobile: boolean
    @Output() publishModeEmitter: EventEmitter<boolean> = new EventEmitter()
    canEditAccount = false


    previewVenue: Venue
    hideTimeline = false
    subPages: PublishSubpage[] = ['DESIGN', 'CONFIGURE', 'PREVIEW', 'PUBLISHED']
    hiddenMobileSubpages: Set<PublishSubpage> = new Set(['DESIGN', 'CONFIGURE'])
    openPage: PublishSubpage = 'DESIGN' 

    eventData: PublicEventData
    eventDataPreview: PublicEventData
    tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 

    publishedMadeWithJoi = true
    previewMadeWithJoi = true

    loadingPreview = true
    loadingPublished = true

    processing = false;
    showSuccess = false;
    successTime = 3000;
    statusToColor = publishStatusToColor
    statusToText = publishStatusToText
    venueSelections: VenueSelection[]
    publicHelpers = publicHelpers
    baseUrl = `${environment.joi.shareBase}${shareUrlsByType.publish}/`

    performers: Dictionary<Performer>
    sponsors: Dictionary<Sponsor>
    exhibitors: Dictionary<Exhibitor>

    constructor() {
      super()
      this.uiService.changePageTitle("Publish",true)
      this.subProp(this.store.select('performers', 'entities'), 'performers')
      this.subProp(this.store.select('exhibitors', 'entities'), 'exhibitors')
      this.subProp(this.store.select('sponsors', 'entities'), 'sponsors')
      this.selectProp(clipboardEditingPrivilegesReselector, null, 'canEditAccount')
    }

    
    async change(brandingOption: BrandOption) {
      console.log("Should be opening branding options dialogue and changing " + brandingOption)
      const data: ManageBrandingData = { selectedTab: brandingOption, type: 'publish', publishId: this.publishInfo.publishCode, onAccount: this.canEditAccount  }
      await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    }

    ngOnInit() {
      if (this.startMobile) this.openPage = 'PREVIEW'

      // console.log("Program publish view initialized!")
      // if (this.publishInfo.status === 'published') this.openPage = 'PUBLISH'

      // console.log({ publishInfo: this.publishInfo, tabNames: this.tabNames })
      if (this.publishInfo.tabNames) this.tabNames = this.publishInfo.tabNames
      this.filtersService.filterAndLoadTimelineFilters(this.publishInfo.filters)

      // console.log({ initialPublishInfo: jsonCopyObject(this.publishInfo) })

      this.previewMadeWithJoi = this.publishInfo.excludedFieldIds ? !this.publishInfo.excludedFieldIds.includes('madeWithJoi') : true

      this.subCallback(this.store.select(venueSelectionsReselector), venueSelections => {
        // console.log({ venueSelections })
        this.venueSelections = venueSelections
      })

      this.publishInfo.status === 'published' && this.sharePublishService.downloadAndDispatchPublishedEvent(this.publishInfo.publishCode)

      this.subCallback(this.store.select('shareables', 'published_data'), (publishedEventDataMap: {[key:string]: PublicEventData }) => {
        const publishedEventData = publishedEventDataMap[this.publishInfo.publishCode]
        // console.log({ publishedInfo })
        if (publishedEventData) {
          this.loadingPublished = false
        }
        this.eventData = publishedEventData
        // console.log({ publishedEventData, publishedEventDataMap, publishCode: this.publishInfo.publishCode, publishInfo: this.publishInfo })
        if(this.eventData && !this.eventData.eventInfo.exhibitorIds){
          delete this.tabNames.exhibitorsTab;
        }
        this.publishedMadeWithJoi = publishedEventData ? !publishedEventData.hideMadeWithJoi : true

      })

      this.subCallback(this.store.select(publicEventDataReselector, { publishCode: this.publishInfo.publishCode, filter: true }), ({ eventData, linkedVenue }: PublishReselectorData) => {
        if (eventData) this.loadingPreview = false
        this.eventDataPreview = eventData
        this.previewVenue = linkedVenue
        // console.log({ linkedVenue })
      })
    }

    emailGenerator(publishCode: string) {
      const timeline = this.eventData?.timeline
      const date = timeline ? timeline[0][0]?.date : null
      const dateText = date ? `, ${compactDate(str2Date(date))}` : ''
      const title = this.event.title || 'untitled event'
      const subject = `Program for ${title}${dateText}`
      const body = `Hi there,\n\nPlease see below a link to the program for ${title}${dateText}:\n\n${publishCode}\n\nThanks`
      return generateEmailLink(subject, body)
    }

    async selectEntities(tagType: TagType) {
      const rect = document.getElementById(`${tagType}-block`).getBoundingClientRect()
      const selectedEntities = {}
      
      let preTaggedIds, entities
      switch (tagType) {
        case 'performer':
          preTaggedIds = this.publishInfo.homePageData.performerIds || []
          entities = Object.values(this.performers)
          break
        case 'sponsor':
          preTaggedIds = this.publishInfo.homePageData.sponsorIds || []
          entities = Object.values(this.sponsors)
          break
        case 'exhibitor':
          preTaggedIds = this.publishInfo.homePageData.exhibitorIds || []
          entities = Object.values(this.exhibitors)
          break
        default:
          console.log("Missing select ids logic for " + tagType)
          return
      }
      entities.forEach(e => selectedEntities[e.id] = preTaggedIds.includes(e.id))
  
      const data: EntitySelectorData = { 
        tagOnly: true,
        tagTitle: `Choose ${tagType}s`,
        selectedEntities,
        entities, 
        searchPlaceholder: `Search ${tagType}s`, 
        entityName: tagType[0].toUpperCase() + tagType.slice(1) as EntityName,
        rect,
        entityHolderName: tagType.toUpperCase()
      }
      console.log(data)
  
      await openDialogGetResult<Promise<string[]>>(this.dialog, EntitySelectorDialogComponent, { width: '300px', data, disableClose: false, backdropClass: 'clear' })
      const selected = Object.entries(selectedEntities).filter(([_, ticked]) => ticked).map(([id, _]) => id)
      if (listsMatch(selected, preTaggedIds)) return
  
      switch (tagType) {
        case 'performer':
          this.publishInfo.homePageData.performerIds = selected
          break
        case 'sponsor':
          this.publishInfo.homePageData.sponsorIds = selected
          break
        case 'exhibitor':
          this.publishInfo.homePageData.exhibitorIds = selected
          break
      }
  
      this.savePublishInfo()
    }
  
    savePublishInfo() {
      this.sharePublishService.upsertPublishInfo(this.publishInfo)
    }

    editNameAndDescription() {
      this.editPublishView()
    }

    editCallToActionLinks() {
      this.editCTALinks()
    }

    async openFilters() {

      const filterGroupings = await this.filtersService.buildTimelineViewFilterUI()
      const params: FilterDialogComponentParams = { width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.publish, filterGroupings }}
      const filtersApplied = await openDialogGetResult(this.dialog, FiltersDialogComponent, params)
      if (filtersApplied) this.sharePublishService.addPublishFilters(this.publishInfo)

    }

    async editFields() {

      const nestedCheckGroups = jsonCopyObject(programPublishDisplayOptionsNestedFieldCheckGroups)
      const deselectedIds = this.publishInfo.excludedFieldIds || []
      const data: NestedChecksDialogData = {
        title: 'Display options',
        successLabel: 'SAVE',
        deselectedIds: deselectedIds,
        backgroundColor: this.uiService.labelsByType.event.color,
        nestedCheckGroups,
        tabNameMap: this.tabNames || {},
        radioChoices: {
          timeline: deselectedIds.includes('breakDays') ? 'breakDays' : 'default'
        }
      }
      if (this.venueSelections.length) { 
        const pageDisplayOptions = nestedCheckGroups.find(g => g.groupName === 'Page display options')
        const dropdownOptions = this.venueSelections.map(s => ({ title: s.displayedTitle, id: s.id }))

        const venueId = this.publishInfo.venueId || ( this.previewVenue ? this.previewVenue.id : null )
        const currentSelection = venueId ? dropdownOptions.find(o => o.id === venueId) : dropdownOptions[0]

        pageDisplayOptions.endingTabDropdown = {
          title: 'Primary Venue',
          id: 'primaryVenue',
          currentSelection,
          dropdownOptions,
          dropdownTitle: 'SELECT PRIMARY VENUE',
          toggleOptions: ['OFF', 'ON'],
        }
        data.currentValues = { 'venue': venueId }
      }  
      console.log(data)

      const result = await openDialogGetResult<NestedChecksReturnData>(this.dialog, NestedChecksDialogComponent, { width: '480px', disableClose: true, data })

      if (!result) return
      console.log(result)
      let venueId = result.valueSelections.venue 
      venueId = result.deselectedIds.includes('primaryVenue') || !venueId ? null : venueId

      this.sharePublishService.addExcludedFields(this.publishInfo, result.deselectedIds, result.tabNameMap)
      this.hideTimeline = true // need time to update expanded default option, and need allow it to initialize, so it responds (since the component was already loaded with defaults)
      await sleepForMS(100)
      this.hideTimeline = false

      if (venueId !== this.publishInfo.venueId) this.sharePublishService.saveVenueIdToPublishInfo(this.publishInfo.publishCode, venueId)
      this.tabNames = result.tabNameMap
      this.previewMadeWithJoi = !result.deselectedIds.includes('madeWithJoi')

      
    }
    confirmPublishAction(publish:boolean){
      const data: ConfirmPublishActionDialogData = { publish, currently_published: this.publishInfo.status === 'published' }
      openDialogGetResult(this.dialog, ConfirmProgramPublishActionDialogComponent, { width: '480px', disableClose: true, data })
        .then(result => result && (publish? this.publish : this.unpublish).bind(this)())
    }

    succeedTemporarily() { // as we all know, success is ephemeral =0 =0 =0
      this.showSuccess = true
      setTimeout(() => this.showSuccess = false, this.successTime)
    }

    async editSliderImage(index: number) {
      const data: SliderImageDialogData = {
        sliderImage: index === null ? null : this.publishInfo.homePageData.sliderImages[index],
        accountId: this.publishInfo.accountId,
        eventId: this.event.eventId,
        imageType: 'publish-slider'
      }
      const sliderImage = await this.openDialogGetResult<SliderImage | { delete: true }>(SliderImageDialogComponent, { width: '440px', disableClose: true, data })
      if (!sliderImage) return
      if ('delete' in sliderImage) {
        removeFromListByIndex(this.publishInfo.homePageData.sliderImages, index)
      } else if (index === null) {
        if (!this.publishInfo.homePageData.sliderImages) this.publishInfo.homePageData.sliderImages = []
        this.publishInfo.homePageData.sliderImages.push(sliderImage)
      } else {
        this.publishInfo.homePageData.sliderImages[index] = sliderImage
      }
      this.savePublishInfo()
    }

    publish() {
      console.log("PUBLISH CALLED")
      this.processing = true;
      this.publishInfo.tabNames = this.tabNames
      this.sharePublishService.publishEvent(this.publishInfo, this.publishInfo.title, this.event).then(hasError=>{
        this.processing = false
        if (!hasError) this.openPage = 'PUBLISHED'
        this.succeedTemporarily()
        this.publishedMadeWithJoi = this.publishInfo.excludedFieldIds ? !this.publishInfo.excludedFieldIds.includes('madeWithJoi') : true
      })
    }

    unpublish() {
      this.processing = true
      const { publishCode, title, description } = this.publishInfo
      this.sharePublishService.unpublishPublishView(publishCode).then(error => {
        this.processing = false
        if (!error) this.succeedTemporarily()
      })
    }

}


